import { useContext } from 'react';
import { ImprovedDialogContext } from '../context/ImprovedDialogProvider';

const useImprovedDialog = () => {
  const { setDialog, showDialog } = useContext(ImprovedDialogContext) || {};
  return { setDialog, showDialog };
};

export default useImprovedDialog;
